import { getPackagePath, getProductId } from '../services';
import { t } from 'i18next';
import AxiosClient from './AxiosClient';
import { getHeaders } from './HttpUtil';
import { ApiUrl, ESalesTextType } from '../data/Constants';

import type { IError, ISalesTextRequest } from '../../types/IApiTypes';

export const SalesTextApi = {
  salesText: (action: ISalesTextRequest) => {
    const productModel = action.modelId ? action.modelId : getProductId();
    const headers = getHeaders(action.token, action.language).headers;
    if (action.apiType === ESalesTextType.Long) {
      headers.skipLoader = 'true';
    }
    return AxiosClient.get(ApiUrl.SalesTextApi, {
      params: {
        packagePath: getPackagePath(getProductId()),
        productModel: action.modelId,
        type: action.apiType,
      },
      headers,
    })
      .then((response) => {
        return {
          salesText: response.data,
          apiType: action.apiType,
          modelId: productModel,
        };
      })
      .catch((err: IError) => {
        if (action.showError) {
          return {
            error: {
              code: err.response?.status,
              message: t('salesText.notFound'),
            },
          };
        }
        throw new Error('Sales text not found');
      });
  },
};
